var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary","size":"mini"},on:{"click":_vm.childclick}},[_vm._t("default",function(){return [_vm._v("下移")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }